import { render } from "./SejourMedicalView.vue?vue&type=template&id=0c3bea1e"
import script from "./SejourMedicalView.vue?vue&type=script&lang=js"
export * from "./SejourMedicalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__